export default "__VITE_ASSET__BX9BlrXN__"